import React from "react";
import { Button } from "reactstrap";

const DepartmentTabs = ({ tab, setTab }) => {
  return (
    <div className="d-flex gap-2 mb-3">
      <Button
        color={tab === "active" ? "primary" : "light"}
        onClick={() => setTab("active")}
        className="btn-rounded"
      >
        Active
      </Button>

      <Button
        color={tab === "inactive" ? "danger" : "light"}
        onClick={() => setTab("inactive")}
        className="btn-rounded hidden"
      >
        Inactive
      </Button>
    </div>
  );
};

export default DepartmentTabs;